import { FC } from 'react';
import { useMount } from 'react-use';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import './CookieBanner.scss';
import { getCookieConsentConfig } from './cookie.utils';
import { useCookieContext } from './CookieContext';

const CookieBanner: FC<{ lang: string; eventId: string }> = ({ lang = 'fr', eventId }) => {
  const { hasCookieBanner } = useCookieContext();
  useMount(() => {
    if (hasCookieBanner) {
      CookieConsent.run(getCookieConsentConfig(eventId, lang));
    }
  });

  return null;
};

export default CookieBanner;
